import React from 'react';
import unique from 'unique-selector';
import { TabContext } from 'components/app-context/TabContextProvider';

export function useTabbableClick(
  path?: string,
  tabbable?: boolean,
  onClick?: Function,
) {
  const { dispatch } = React.useContext(TabContext);
  return React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (tabbable && !event.ctrlKey) {
        event.preventDefault();
        dispatch({
          type: 'ADD_TAB',
          tab: {
            uri: path,
            initiator: unique(event.target),
          },
        });
      }
      onClick && onClick(event);
    },
    [dispatch, tabbable, path, onClick],
  );
}
